import { SVGProps, Ref, forwardRef } from 'react';

export const GamepadFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.13 6.665c0 .188-.048.3-.093.354-.026.031-.104.113-.373.113-.27 0-.348-.082-.374-.113-.044-.054-.093-.166-.093-.354s.049-.3.093-.353c.026-.032.105-.113.374-.113s.347.081.373.113c.045.053.093.166.093.353"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 7.647C0 3.412 1.333 2 5.333 2h5.334C14.667 2 16 3.412 16 7.647v2.647C16 12.941 14.998 14 13.667 14c-.93 0-1.642-.608-2.406-1.26-.882-.753-1.832-1.563-3.261-1.563s-2.379.81-3.26 1.563C3.976 13.392 3.263 14 2.333 14 1.002 14 0 12.941 0 10.294zm11.664.885c.605 0 1.11-.21 1.449-.617.32-.384.417-.854.417-1.25 0-.395-.098-.866-.417-1.25-.339-.406-.844-.616-1.45-.616-.605 0-1.11.21-1.448.616-.32.384-.418.855-.418 1.25 0 .396.098.866.418 1.25.338.407.843.617 1.449.617M4.332 5.675l.838-.838.99.99-.838.838.838.838-.99.99-.838-.838-.838.838-.99-.99.838-.838-.838-.838.99-.99z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GamepadFilledSize16Glyph.displayName = 'GamepadFilledSize16Glyph';
